import React, { Suspense, lazy, useState } from 'react';
import { Menu, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import getPublicAssetUrl from '../utils/publicAsset';
import './Nav.css';

const LoginPopup = lazy(() => import('./LoginPopup'));
const { Title } = Typography;

const Nav = ({ current, handleClick, isLoggedIn, onLoginSuccess, hideMenu = false }) => {
  const [loginVisible, setLoginVisible] = useState(false);

  const showLogin = () => setLoginVisible(true);
  const hideLogin = () => setLoginVisible(false);

  return (
    <div className="landing-header">
      <div className="logo">
        <img src={getPublicAssetUrl('/yinke_logo.png')} alt="Notolang's logo" className="logo-image" />
        <Title level={4} style={{ margin: 0 }}>Notolang</Title>
      </div>
      {!hideMenu && (
        <Menu onClick={handleClick} selectedKeys={[current]} mode="horizontal">
          <Menu.Item key="dictation">
            <Link to="/dictation">听抄训练</Link>
          </Menu.Item>
          <Menu.Item key="shadowing">
            <Link to="/shadowing">影子跟读</Link>
          </Menu.Item>
          <Menu.Item key="help">
            <Link to="/help">帮助中心</Link>
          </Menu.Item>
          <Menu.Item key="about">
            <Link to="/about">关于我们</Link>
          </Menu.Item>
          <Menu.Item key="contact">
            <Link to="/contact">联系我们</Link>
          </Menu.Item>
        </Menu>
      )}
      {!isLoggedIn && (
        <Button type="primary" onClick={showLogin}>
          登录
        </Button>
      )}
      {loginVisible && (
        <Suspense fallback={null}>
          <LoginPopup
            visible={loginVisible}
            onClose={hideLogin}
            onLoginSuccess={onLoginSuccess}
          />
        </Suspense>
      )}
    </div>
  );
};

export default Nav;
